// constants go here
import {
  MRT_ShowHideColumnsButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleGlobalFilterButton,
  MRT_TablePagination,
  MRT_GlobalFilterTextField
} from 'material-react-table'
import HomeIcon from '@mui/icons-material/Home';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import HelpIcon from '@mui/icons-material/Help';
import TableDownloadButton from './components/TableDownloadButton'
import AddSegmentExample from './images/AddSegmentsExample.gif'

export const API_ROOT = 'https://ilmat-api-evf8crbtgyckhtdz.centralus-01.azurewebsites.net/api'
// export const API_ROOT = 'http://127.0.0.1:8000/api'
export const fetcher = apiURL => fetch(`${API_ROOT}${apiURL}`, {
  headers: {
    'Content-Type': 'application/json',
  }
}).then(res => res.json())

// function inspired by ChatGPT
export function isArrayNonEmptySubset(array1, array2) {
  if (array1.length === 0 || array2.length === 0) {
    return false
  }
  return array1.every(e => array2.includes(e))
}
export const GEOGRAPHIES_DEFAULT = {
  "counties": {
      "1": "ADAMS",
      "10": "CHAMPAIGN",
      "100": "WILLIAMSON",
      "101": "WINNEBAGO",
      "102": "WOODFORD",
      "11": "CHRISTIAN",
      "12": "CLARK",
      "13": "CLAY",
      "14": "CLINTON",
      "15": "COLES",
      "16": "COOK",
      "17": "CRAWFORD",
      "18": "CUMBERLAND",
      "19": "DEKALB",
      "2": "ALEXANDER",
      "20": "DEWITT",
      "21": "DOUGLAS",
      "22": "DUPAGE",
      "23": "EDGAR",
      "24": "EDWARDS",
      "25": "EFFINGHAM",
      "26": "FAYETTE",
      "27": "FORD",
      "28": "FRANKLIN",
      "29": "FULTON",
      "3": "BOND",
      "30": "GALLATIN",
      "31": "GREENE",
      "32": "GRUNDY",
      "33": "HAMILTON",
      "34": "HANCOCK",
      "35": "HARDIN",
      "36": "HENDERSON",
      "37": "HENRY",
      "38": "IROQUOIS",
      "39": "JACKSON",
      "4": "BOONE",
      "40": "JASPER",
      "41": "JEFFERSON",
      "42": "JERSEY",
      "43": "JODAVIESS",
      "44": "JOHNSON",
      "45": "KANE",
      "46": "KANKAKEE",
      "47": "KENDALL",
      "48": "KNOX",
      "49": "LAKE",
      "5": "BROWN",
      "50": "LASALLE",
      "51": "LAWRENCE",
      "52": "LEE",
      "53": "LIVINGSTON",
      "54": "LOGAN",
      "55": "MCDONOUGH",
      "56": "MCHENRY",
      "57": "MCLEAN",
      "58": "MACON",
      "59": "MACOUPIN",
      "6": "BUREAU",
      "60": "MADISON",
      "61": "MARION",
      "62": "MARSHALL",
      "63": "MASON",
      "64": "MASSAC",
      "65": "MENARD",
      "66": "MERCER",
      "67": "MONROE",
      "68": "MONTGOMERY",
      "69": "MORGAN",
      "7": "CALHOUN",
      "70": "MOULTRIE",
      "71": "OGLE",
      "72": "PEORIA",
      "73": "PERRY",
      "74": "PIATT",
      "75": "PIKE",
      "76": "POPE",
      "77": "PULASKI",
      "78": "PUTNAM",
      "79": "RANDOLPH",
      "8": "CARROLL",
      "80": "RICHLAND",
      "81": "ROCK ISLAND",
      "82": "ST. CLAIR",
      "83": "SALINE",
      "84": "SANGAMON",
      "85": "SCHUYLER",
      "86": "SCOTT",
      "87": "SHELBY",
      "88": "STARK",
      "89": "STEPHENSON",
      "9": "CASS",
      "90": "TAZEWELL",
      "91": "UNION",
      "92": "VERMILION",
      "93": "WABASH",
      "94": "WARREN",
      "95": "WASHINGTON",
      "96": "WAYNE",
      "97": "WHITE",
      "98": "WHITESIDE",
      "99": "WILL"
  },
  "districts": {
      "1": "Schaumburg",
      "2": "Dixon",
      "3": "Ottawa",
      "4": "Peoria",
      "5": "Paris",
      "6": "Springfield",
      "7": "Effingham",
      "8": "Collinsville",
      "9": "Carbondale"
  },
  "mpos": {
      "0000": "Not in MPO",
      "0540": "Bloomington-Normal",
      "0865": "Carbondale",
      "0990": "Champaign-Urbana",
      "1051": "Chicago",
      "1395": "Danville",
      "1410": "Decatur",
      "1435": "De Kalb-Sycamore",
      "1603": "East Cape Girardeau",
      "1615": "East Dubuque",
      "1660": "East St. Louis",
      "2915": "Kankakee",
      "4590": "Peoria",
      "4965": "Rockford",
      "4970": "Rock Island-Moline",
      "5400": "South Beloit-Rockton",
      "5480": "Springfield"
  },
  "regions": {
      "1": "Region 1",
      "2": "Region 2",
      "3": "Region 3",
      "4": "Region 4",
      "5": "Region 5"
  }
}
export const REP_DISTRICTS = Array.from({ length: 118 }, (_, i) => i+1)
export const CONG_DISTRICTS = Array.from({ length: 18 }, (_, i) => i+1)

// colors source: https://colorbrewer2.org/#type=qualitative&scheme=Set3&n=5
export const contextLayerColors = [
  [141,211,199],
  [255,255,179],
  [190,186,218],
  [251,128,114],
  [128,177,211],
]

// create tutorial steps based on current route of app
export const TUTORIAL_STEPS = {
  '/roads': [
    {
      title: "Welcome to the ILMAT Roads Module",
      content: "The Illinois Mobility Assessment Tool (ILMAT) gives information about road segments in the state of Illinois, offering a range of features. This tour will guide you through the tool's roads module, highlighting its key functionalities. Select 'Next' to explore the features step by step, select 'Back' to go to a previous step, or select 'Close' to skip the tutorial.",
      anchor: '#drag-handle-icon',
      anchorOrigin: { vertical: 'center', horizontal: 'center' },
      transformOrigin: { vertical: 'center', horizontal: 'center' },
    },
    {
      title: "Top options",
      content: "Select the 'Category' and 'Layer' options above to see data on map and table.",
      anchor: "#roads-options",
      anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      transformOrigin: { vertical: 'top', horizontal: 'center' },
    },
    {
      title: "Icon buttons legend",
      content: (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: 2.5}}>
          <li><HomeIcon /> Go back to the home page.</li>
          <li><LightModeIcon /> Switch to light mode.</li>
          <li><DarkModeIcon /> Switch to dark mode.</li>
          <li><HelpIcon /> View this tutorial again.</li>
        </ul>
      ),
      anchor: "#icon-buttons",
      anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
      transformOrigin: { vertical: 'top', horizontal: 'left' },
    },
    {
      title: 'Map',
      content: 'On the right hand side of the Roads Module is the map, where segment data are shown.',
      anchor: "#roads-map",
      anchorOrigin: { vertical: 'center', horizontal: 'left' },
      transformOrigin: { vertical: 'center', horizontal: 'right' },
    },
    {
      title: 'Summary Table',
      content: 'On the left hand side of the Roads Module is the table, where segment data and attributes are shown.',
      anchor: "#table-with-tabs",
      anchorOrigin: { vertical: 'center', horizontal: 'right' },
      transformOrigin: { vertical: 'center', horizontal: 'left' },
    },
    {
      title: 'Selected Roads Table',
      content: (
        <div style={{height: '50vh'}}>
          <div>When switching to the "Selected Roads" tab, there is a separate table for selected roads. These will display when you press "From here" and "To here" on the map.</div>
          <img src={AddSegmentExample} height='80%' alt='GIF Demonstration of adding segments with the popups.'/>
        </div>
      ),
      anchor: "#table-with-tabs",
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
      transformOrigin: { vertical: 'top', horizontal: 'left' },
    },
  ],
  '/mpo': [
    {
      title: "Welcome to the ILMAT MPO Module",
      content: "The Illinois Mobility Assessment Tool (ILMAT) gives information about road segments in the state of Illinois, offering a range of features. This tour will guide you through the tool's MPO module, highlighting its key functionalities. Select 'Next' to explore the features step by step, select 'Back' to go to a previous step, or select 'Close' to skip the tutorial.",
      anchor: '#drag-handle-icon',
      anchorOrigin: { vertical: 'center', horizontal: 'center' },
      transformOrigin: { vertical: 'center', horizontal: 'center' },
    },
    {
      title: "Top options",
      content: "Select the 'MPO' option above to see data on map and table.",
      anchor: "#roads-options",
      anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      transformOrigin: { vertical: 'top', horizontal: 'center' },
    },
    {
      title: "Icon buttons legend",
      content: (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: 2.5}}>
          <li><HomeIcon /> Go back to the home page.</li>
          <li><LightModeIcon /> Switch to light mode.</li>
          <li><DarkModeIcon /> Switch to dark mode.</li>
          <li><HelpIcon /> View this tutorial again.</li>
        </ul>
      ),
      anchor: "#icon-buttons",
      anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
      transformOrigin: { vertical: 'top', horizontal: 'left' },
    },
    {
      title: 'Map',
      content: 'On the right hand side of the MPO Module is the map, where segment data are shown.',
      anchor: "#roads-map",
      anchorOrigin: { vertical: 'center', horizontal: 'left' },
      transformOrigin: { vertical: 'center', horizontal: 'right' },
    },
    {
      title: 'Summary Table',
      content: 'On the left hand side of the MPO Module is the table, where segment data and attributes are shown.',
      anchor: "#table-with-tabs",
      anchorOrigin: { vertical: 'center', horizontal: 'right' },
      transformOrigin: { vertical: 'center', horizontal: 'left' },
    },
    {
      title: 'Selected Roads Table',
      content: (
        <div>
          <div>When switching to the "Selected Roads" tab, there is a separate table for selected roads. These will display when you press "From here" and "To here" on the map.</div>
          <img src={AddSegmentExample} height='80%' alt='GIF Demonstration of adding segments with the popups.'/>
        </div>
      ),
      anchor: "#table-with-tabs",
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
      transformOrigin: { vertical: 'top', horizontal: 'left' },
    },
    {
      title: 'Monitored Roads Tab',
      content: 'The "Monitored Roads" tab shows the road segments that the MPO has submitted to be consistently tracked for congestion and roadway performance. These segments are submitted by the individual MPO and stored in the ILMAT database. Once submitted, TTI conflates the segmentation onto each new year of data for review by the MPO. Changes can be submitted to either IDOT or TTI through the "Contact Us" section.',
      anchor: "#table-with-tabs",
      anchorOrigin: { vertical: 'center', horizontal: 'right' },
      transformOrigin: { vertical: 'center', horizontal: 'left' },
    },
  ],
};

export const CURRENT_TUTORIAL_VERSION = 'version 03-20-2025'

export const AGGREGATED_COLUMNS = ['aadt']

export const BLUE_YELLOW_FOCUS_COLORS = [
  [37,52,148],
  [65,182,196],
  [161,218,180],
  [255,255,204]
]

export const FOCUS_COLORS = [
  [252,174,145],
  [251,106,74],
  [222,45,38],
  [165,15,21],
]

export const getDefaultMRTOptions = {
  enableColumnOrdering: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  enableGrouping: true,
  enableRowActions: true,
  paginateExpandedRows: true,
  enableFacetedValues: true,
  initialState: {
    density: 'compact',
  },
  renderTopToolbar: ({ table }) => (
    <div style={{ paddingTop: 15, paddingBottom: 15, display: 'flex', alignItems: 'center', height: table.getState().isFullScreen ? '3vh' : '7vh' }}>
      <MRT_ToggleFiltersButton table={table} />
      <MRT_ShowHideColumnsButton table={table} />
      <MRT_ToggleDensePaddingButton table={table} />
      <MRT_ToggleFullScreenButton table={table} />
      <TableDownloadButton table={table} category={null} />
      <MRT_ToggleGlobalFilterButton table={table} />
      <MRT_GlobalFilterTextField table={table} />
    </div>
  ),
  displayColumnDefOptions: {
    'mrt-row-actions': {
      header: '',
    },
  },
  muiTablePaperProps: {
    elevation: 0
  },
  muiTableContainerProps: ({ table }) => ({
    sx: { height: table.getState().isFullScreen ? '86vh' : '61vh', zIndex: 2 }
  }),
  renderBottomToolbar: ({ table }) => (
    <div style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', height: '7vh' }}>
      <MRT_TablePagination table={table} />
    </div>
  )
}

export const renderToLocaleString = ({cell}) => {
  return (
    <>
      {
        typeof cell.getValue() === 'number'
        ? cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })
        : cell.getValue()
      }
    </>
  )
}

export const ROAD_LABELS = [
  {
    category: 'Functional Classification',
    categoryKey: 'fc',
    labels: {
      "Interstate": 1,
      "Freeway and Expressway": 2,
      "Other Principal Arterial": 3,
      "Minor Arterial": 4,
      "Major Collector": 5,
      "Minor Collector": 6
    }
  },
  {
    category: 'Urban/Rural',
    categoryKey: 'urban',
    labels: {
      "Not Urban": 0,
      "Urban": 1
    },
  },
  {
    category: 'National Highway System',
    categoryKey: 'nhs',
    labels: {
      "Not National Highway System": 0,
      "National Highway System not an NHS Connector": 1,
      "NHS Connector Major Airport": 2,
      "NHS Connector Major Port Facility": 3,
      "NHS Connector Major Amtrak Station": 4,
      "NHS Connector Major Rail/Truck Terminal": 5,
      "NHS Connector Major Intercity Bus Terminal": 6,
      "NHS Connector Public Transit or Multi-modal Passenger Terminal": 7,
      "NHS Connector Pipeline Terminal": 8,
      "NHS Connector Major Ferry Terminal": 9
    },
  },
  {
    category: 'National Highway Freight Network',
    categoryKey: 'freight',
    labels: {
      "Not NHFN": 0,
      "NHFN Primary Highway Freight System (PHFS)": 10,
      "NHFN Interstate Non-PHFS": 20,
      "NHFN Interstate Non-PHFS designated Critical Corridor": 21,
      "NHFN Non-Interstates Non-PHFS designated Critical Corridor": 31
    }
  }
]

export const aggregationCols = {
  fc: {
    accessorFn: (row) => Object.entries(ROAD_LABELS[0].labels).find(d => d[1] === row.fc)[0],
    id: 'fc',
    header: 'Functional Classification',
    filterVariant: 'multi-select'
  },
  urban: {
    accessorFn: (row) => row.urban === 0 ? 'Not urban' : 'Urban',
    id: 'urban',
    header: 'Urban/Rural',
    aggregationFn: 'unique',
    AggregatedCell: ({cell}) => <>{cell.getValue().join()}</>,
    filterVariant: 'multi-select',
  },
  nhs: {
    accessorFn: (row) => Object.entries(ROAD_LABELS[2].labels).find(d => d[1] === row.nhs)[0],
    id: 'nhs',
    header: 'National Highway System',
    filterVariant: 'multi-select',
  },
  freight: {
    accessorFn: (row) => Object.entries(ROAD_LABELS[3].labels).find(d => d[1] === row.freight)[0],
    id: 'freight',
    header: 'National Highway Freight Network',
    filterVariant: 'multi-select',
  }
}

export function getWeightedAverage(rows, valueID, weightID) {
  let weightedValueSum = 0
  let weightSum = 0
  for (const row of rows) {
    weightedValueSum += (row[valueID] * row[weightID])
    weightSum += row[weightID]
  }
  return weightedValueSum / weightSum
}

export const TABLE_COLS =
  [
    {
      accessorKey: 'inventory',
			id: 'inventory',
      header: 'Inventory Key Route ID',
      enableHiding: false,
    },
    // {
    //   accessorKey: 'year',
		// 	id: 'year',
    //   header: 'Year',
    //   muiTableBodyCellProps: {
    //     align: 'right',
    //   }
    // },
    {
      accessorKey: 'beg_sta',
			id: 'beg_sta',
      header: 'Begin Milepoint',
      enableGrouping: false,
      Cell: ({ cell }) => {
        const formattedValue = cell.getValue().toLocaleString('en-US', { minimumFractionDigits: 2,
          maximumFractionDigits: 2
          });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'end_sta',
			id: 'end_sta',
      header: 'End Milepoint',
      enableGrouping: false,
      Cell: ({ cell }) => {
        const formattedValue = cell.getValue().toLocaleString('en-US', { minimumFractionDigits: 2,
          maximumFractionDigits: 2
          });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    // {
    //   accessorKey: 'top100id',
		//	 id: 'top100id',
    //   header: 'Top 100 ID'
    // },
    {
      accessorKey: 'aadt',
			id: 'aadt',
      header: 'AADT',
      enableGrouping: false,
      size: 48,
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'aadt', 'seg_length'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { minimumFractionDigits: 2,
          maximumFractionDigits: 2
          })}</div>,
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'aadt_yr',
			id: 'aadt_yr',
      header: 'AADT Year',
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'delay',
			id: 'delay',
      header: 'Annual Person Hours of Delay',
      aggregationFn: 'sum',
      AggregatedCell: ({cell}) => <>{cell.getValue().toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}</>,
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'trkdelay',
			id: 'trkdelay',
      header: 'Annual Truck Vehicle Hours of Delay',
      aggregationFn: 'sum',
      AggregatedCell: ({cell}) => <>{cell.getValue().toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}</>,
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'allfuel',
			id: 'allfuel',
      header: 'Annual Excess Fuel Used Due to Congestion (Gallons)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-us', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'trkfuel',
			id: 'trkfuel',
      header: 'Annual Excess Fuel Used Due to Truck Congestion (Gallons)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-us', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'congcost',
			id: 'congcost',
      header: 'Annual Congestion Cost',
      aggregationFn: 'sum',
      AggregatedCell: ({cell}) => <>{cell.getValue().toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}</>,
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'ttivmt',
			id: 'ttivmt',
      header: 'Peak VMT',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      aggregationFn: 'sum',
      AggregatedCell: ({cell}) => <>{cell.getValue().toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}</>,
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'trkttivmt',
			id: 'trkttivmt',
      header: 'Peak Truck VMT',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      aggregationFn: 'sum',
      AggregatedCell: ({cell}) => <>{cell.getValue().toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}</>,
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'commcost',
			id: 'commcost',
      header: 'Commodity Cost',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'pkdly',
			id: 'pkdly',
      header: 'Peak Period Annual Hours of Delay (Person-hours)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'opdly',
			id: 'opdly',
      header: 'Off-Peak Annual Hours of Delay (Person-hours)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'wedly',
			id: 'wedly',
      header: 'Weekend Annual Hours of Delay (Person-hours)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'pktrkdly',
			id: 'pktrkdly',
      header: 'Peak Period Annual Hours of Truck Delay (Person-hours)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'optrkdly',
			id: 'optrkdly',
      header: 'Off-Peak Annual Hours of Truck Delay (Person-hours)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'wetrkdly',
			id: 'wetrkdly',
      header: 'Weekend Person Hours of Truck Delay (Person-hours)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'tti',
			id: 'tti',
      header: 'TTI',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'tti', 'ttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'allspeed',
			id: 'allspeed',
      header: 'Average Peak Period Speed (based on 6-9am, 4-7pm)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'allspeed', 'ttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'allrefspeed',
			id: 'allrefspeed',
      header: 'Freeflow Speed for All Vehicles',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'allrefspeed', 'ttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'pti95',
			id: 'pti95',
      header: 'PTI - 95th Percentile',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'pti95', 'ttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'pti80',
			id: 'pti80',
      header: 'PTI - 80th Percentile',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'pti80', 'ttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'estimated',
			id: 'estimated',
      header: 'Estimated',
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'trktti',
			id: 'trktti',
      header: 'Truck TTI',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'trktti', 'trkttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'trkspeed',
			id: 'trkspeed',
      header: 'Average Truck Peak Period (based on 6-9am, 4-7pm)',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'trkspeed', 'trkttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'trkrefspeed',
			id: 'trkrefspeed',
      header: 'Freeflow Speed for Trucks',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'trkrefspeed', 'trkttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'trkpti95',
			id: 'trkpti95',
      header: 'Truck PTI - 95th Percentile',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'trkpti95', 'trkttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'trkpti80',
			id: 'trkpti80',
      header: 'Truck PTI - 80th Percentile',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      aggregationFn: (a, rows) => getWeightedAverage(rows.map(r => r.original), 'trkpti80', 'trkttivmt'),
      AggregatedCell: ({cell}) => <div>{cell.getValue().toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>,
    },
    {
      accessorKey: 'hcv',
			id: 'hcv',
      header: 'Annual Average Daily Heavy Commercial Volume',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'hcv_mu_yr',
			id: 'hcv_mu_yr',
      header: 'Annual Average Daily Single Unit and Multiple Unit Volume Year',
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'mu_vol',
			id: 'mu_vol',
      header: 'Annual Average Daily Multiple Unit Volume',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'seg_length',
			id: 'seg_length',
      header: 'Length',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    {
      accessorKey: 'su_vol',
			id: 'su_vol',
      header: 'Annual Average Daily Single Unit Volume',
      Cell: ({ cell }) => {
        const formattedValue = Number(cell.getValue()).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return <span>{formattedValue}</span>;
      },
      muiTableBodyCellProps: {
        align: 'right',
      }
    },
    // {
    //   accessorKey: 'cong',
		// 	id: 'cong',
    //   header: 'Congressional District',
    // },
    // {
    //   accessorKey: 'dist',
			// id: 'dist',
    //   header: 'District',
    // },
    // {
    //   accessorKey: 'county_nam',
			// id: 'county_nam',
    //   header: 'County Name',
    // },
    // {
    //   accessorKey: 'inv_co',
			// id: 'inv_co',
    //   header: 'County',
    // },
    // {
    //   accessorKey: 'mpo',
			// id: 'mpo',
    //   header: 'MPO',
    // },
    // {
    //   accessorKey: 'muni_name',
			// id: 'muni_name',
    //   header: 'Municipality Name',
    // },
    // {
    //   accessorKey: 'rep',
			// id: 'rep',
    //   header: 'Representative District',
    // },
    // {
    //   accessorKey: 'township_n',
			// id: 'township_n',
    //   header: 'Township Name',
    // },
    // {
    //   accessorKey: 'urban',
			// id: 'urban',
    //   header: 'Urban',
    // },
    // {
    //   accessorKey: 'ch',
			// id: 'ch',
    //   header: 'CH',
    // },
    // {
    //   accessorKey: 'fc_name',
			// id: 'fc_name',
    //   header: 'FC Name',
    // },
    // {
    //   accessorKey: 'freight',
			// id: 'freight',
    //   header: 'Freight',
    // },
    // {
    //   accessorKey: 'iri_low',
			// id: 'iri_low',
    //   header: 'IRI Low',
    // },
    // {
    //   accessorKey: 'iri_opp',
			// id: 'iri_opp',
    //   header: 'Iri Opp',
    // },
    // {
    //   accessorKey: 'iri_with',
		//	id: 'iri_with',
    //   header: 'IRI With',
    // },
    // {
    //   accessorKey: 'jur_type',
		//	id: 'jur_type',
    //   header: 'Juristiction Type',
    // },
    // {
    //   accessorKey: 'key_rt_app',
		//	id: 'key_rt_app',
    //   header: 'Key RT App',
    // },
    // {
    //   accessorKey: 'ln_spc',
		//	id: 'ln_spc',
    //   header: 'LN SPC',
    // },
    // {
    //   accessorKey: 'ln_spc_nbr',
		//	id: 'ln_spc_nbr',
    //   header: 'LN SPC NBR',
    // },
    // {
    //   accessorKey: 'ln_spc_wth',
		//	id: 'ln_spc_wth',
    //   header: 'ln spc wth',
    // },
    // {
    //   accessorKey: 'ln_wth',
		//	id: 'ln_wth',
    //   header: 'ln wth',
    // },
    // {
    //   accessorKey: 'lns',
		//	id: 'lns',
    //   header: 'LNS',
    // },
    // {
    //   accessorKey: 'maint_type',
			// id: 'maint_type',
    //   header: 'maint type',
    // },
    // {
    //   accessorKey: 'marked_rt',
			// id: 'marked_rt',
    //   header: 'marked rt',
    // },
    // {
    //   accessorKey: 'marked_rt2',
		// id: 'marked_rt2',
    //   header: 'marked rt 2',
    // },
    // {
    //   accessorKey: 'marked_rt3',
			// id: 'marked_rt3',
    //   header: 'marked rt 3',
    // },
    // {
    //   accessorKey: 'marked_rt4',
			// id: 'marked_rt4',
    //   header: 'marked rt4',
    // },
    // {
    //   accessorKey: 'med_typ',
			// id: 'med_typ',
    //   header: 'med typ',
    // },
    // {
    //   accessorKey: 'med_wth',
			// id: 'med_wth',
    //   header: 'med wth',
    // },
    // {
    //   accessorKey: 'nhs',
			// id: 'nhs',
    //   header: 'NHS'
    // },
    // {
    //   accessorKey: 'op_1_2_way',
			// id: 'op_1_2_way',
    //   header: 'op 1 2 way'
    // },
    // {
    //   accessorKey: 'pl_agy',
			// id: 'pl_agy',
    //   header: 'pl agy'
    // },
    // {
    //   accessorKey: 'prk_lt',
			// id: 'prk_lt',
    //   header: 'prk lt'
    // },
    // {
    //   accessorKey: 'prk_rt',
			// id: 'prk_rt',
    //   header: 'prk rt'
    // },
    // {
    //   accessorKey: 'road_name',
			// id: 'road_name',
    //   header: 'Road Name'
    // },
    // {
    //   accessorKey: 'sp_lim',
			// id: 'sp_lim',
    //   header: 'sp lim'
    // },
    // {
    //   accessorKey: 'toll',
			// id: 'toll',
    //   header: 'Toll'
    // },
    // {
    //   accessorKey: 'trk_rt',
			// id: 'trk_rt',
    //   header: 'Truck RT'
    // }
  ]
const MONITORED_ROAD_NAMES = [
  { name: 'roadname', fullName: 'Road Name'},
  { name: 'top100id', fullName: 'Segmentation ID' },
  { name: 'inv_co', fullName: 'County Number' },
  { name: 'dist', fullName: 'District' },
  { name: 'length_il100seg', fullName: 'Segmentation Length' },
  { name: 'aadt_il100seg', fullName: 'AADT' },
  { name: 'vmt_il100seg', fullName: 'VMT' },
  { name: 'arank', fullName: 'All - Vehicle Segment Rank' },
  { name: 'dmile', fullName: 'Person Hours of Delay Per Mile' },
  { name: 'tti', fullName: 'TTI' },
  { name: 'pti', fullName: 'PTI ' },
  { name: 'spd', fullName: 'Average Peak Period Speed (Based On 6-9am, 4-7pm)' },
  { name: 'rspd', fullName: 'Freeflow Speed For All Vehicles' },
  { name: 'pkdly', fullName: 'Peak Period Annual Hours Of Delay (Person-hours)' },
  { name: 'opdly', fullName: 'Off-peak Annual Hours Of Delay (Person-hours)' },
  { name: 'wedly', fullName: 'Weekend Annual Hours Of Delay (Person-hours)' },
  { name: 'delay', fullName: 'Person Hours of Delay' },
  { name: 'cost', fullName: 'Congested Cost' },
  { name: 'fuel', fullName: 'Annual Excess Fuel Used Due To Congestion (Gallons)' },
  { name: 'taadt_il100seg', fullName: 'Truck AADT' },
  { name: 'tvmt_il100seg', fullName: 'Truck VMT' },
  { name: 'sintaadt_il100seg', fullName: 'AADT Single Unit Truck' },
  { name: 'sintvmt_il100seg', fullName: 'Single Unit Truck VMT' },
  { name: 'comtaadt_il100seg', fullName: 'AADT combination Truck' },
  { name: 'comtvmt_il100seg', fullName: 'Combination Truck VMT' },
  { name: 'trkrank', fullName: 'Rank -- Truck Delay Rank' },
  { name: 'trkdmile', fullName: 'Truck Person Hours of Delay Per Mile' },
  { name: 'trktti', fullName: 'Truck Congestion Index' },
  { name: 'trkpti', fullName: 'Truck PTI' },
  { name: 'trkspd', fullName: 'Average Truck Peak Period Speed (Based On 6-9am, 4-7pm)' },
  { name: 'trkrspd', fullName: 'Freeflow Speed For Trucks' },
  { name: 'pktrkdly', fullName: 'Peak Period Annual Hours Of Truck Delay (Person-hours)' },
  { name: 'optrkdly', fullName: 'Off-peak Annual Hours Of Truck Delay (Person-hours)' },
  { name: 'wetrkdly', fullName: 'Weekend Person Hours Of Truck Delay (Person-hours)' },
  { name: 'trkdelay', fullName: 'Truck Person Hours Of Delay' },
  { name: 'trkcost', fullName: 'Truck Congested Cost' },
  { name: 'trkfuel', fullName: 'Annual Excess Fuel Used Due To Truck Congestion (Gallons)' },
  { name: 'pc_estimated', fullName: 'Percentage Estimated' },
]

export const MONITORED_ROAD_COLS = MONITORED_ROAD_NAMES.map(d => ({
  accessorKey: `properties.${d.name}`,
  id: d.name,
  header: d.fullName,
}))

// export const getAggregatedColumns = (aggregation, aggregationKeys) => {
//   console.log(TABLE_COLS.filter(c => aggregationKeys.includes(c.id)))
//   return [aggregationCols[aggregation], ...TABLE_COLS.filter(c => aggregationKeys.includes(c.accessorKey))]
// }
// export const SELECTED_AGGREGATED_COLS = TABLE_COLS.filter(c => ['inventory', 'beg_sta', 'end_sta', 'year', 'aadt', 'delay', 'trkdelay', 'congcost', 'ttivmt', 'trkttivmt', 'tti', 'allspeed', 'allrefspeed', 'pti95', 'pti80', 'trktti', 'trkspeed', 'trkrefspeed', 'trkpti95', 'trkpti80'].includes(c.id))
export const FOCUS_COLS = TABLE_COLS.filter(c => !['inventory', 'beg_sta', 'end_sta', 'year', 'aadt_yr', 'estimated'].includes(c.accessorKey))

export const ROAD_LABELS_NAMES = ROAD_LABELS.map(c => Object.keys(c.labels).map(l => `${c.categoryKey}-${c.labels[l]}`)).flat()
export const ROAD_LABELS_NAMES_LENGTH = ROAD_LABELS_NAMES.length